// Modules
import React, { useState, useEffect } from "react"

import { getRequest }      from '@react/helpers/fetch'
import { library }         from '@fortawesome/fontawesome-svg-core'
import { fas }             from '@fortawesome/free-solid-svg-icons'
library.add(fas)

import { CostsFilters }     from "./costsFilters"
import { CostsStatistics }  from "./costsStatistics"
import { CostsTable, SITE ,NAME, ASC} from "./costsTable"

const App = ({ feedUrl, initialFilter, partners, showRevenue }) => {
  const [state, setState] = useState({
    filter:  initialFilter,
    data:    {},
    loading: true,
    order:   { column: NAME, direction: ASC }
  })

  const { filter } = state

  useEffect(() => {
    setState(prevState => ({ ...prevState, loading: true }))
    const url = new URL(location.origin + feedUrl)
    url.searchParams.set('from', filter.from)
    url.searchParams.set('to',   filter.to)

    if (filter.asset)         { url.searchParams.set(filter.asset.type, filter.asset.id) }
    if (filter.type)          { url.searchParams.set('type', filter.type.map(t => t.id)) }
    if (filter.createdFrom)   { url.searchParams.set('created_from', filter.createdFrom.map(c => c.id)) }
    if (filter.partner?.length) { url.searchParams.set('partner', filter.partner.map(p => p.id)) }

    getRequest(url)
    .then(data => {
      history.replaceState(history.state, document.title, url.href.replace(".json", ""))
      setState(prevState => ({
        ...prevState,
        data,
        loading: false
      }))
    })
  }, [filter])

  const showRevenueOnTable = showRevenue && !(filter.asset?.type == SITE)

  return(
    <div>
      <CostsFilters state={state} setState={setState} partners={partners} showRevenue={showRevenue} />

      { state.loading
        ? <div className="d-flex-center" style={{ margin: "100px 0"}}>
            <div className="dot-elastic"></div>
          </div>
        : <>
            <CostsStatistics
              totals      = {state.data.totals}
              showRevenue = {showRevenue}
            />

            <CostsTable
              state       = {state}
              setState    = {setState}
              showRevenue = {showRevenueOnTable}
            />
          </>
      }
    </div>
  )
}

export default App
